import React from 'react'
import { GatsbyImage, IGatsbyImageData, StaticImage } from 'gatsby-plugin-image'
import type { Property } from 'csstype'

import AvailableFormsOfService from 'components/AvailableFormsOfService'
import { classNames } from 'services/string'
import FAQBox from 'components/FAQ/FAQBox'

interface FAQBoxProps {
  questions?: Queries.FAQInfoFragment[]
  extraQuestions?: Queries.FAQInfoFragment[]
  primaryColor?: Property.Color
  secondaryColor?: Property.Color
  image?: IGatsbyImageData
  disableContactOptions?: boolean
}

const FAQ = ({ primaryColor, image, disableContactOptions, ...rest }: FAQBoxProps) => {
  return (
    <div
      className={classNames(
        'flex flex-col gap-16 lg:gap-8 xl:gap-16 py-12 xl:py-20',
        disableContactOptions ? 'lg:items-center' : 'lg:flex-row',
      )}
    >
      <div className={classNames('flex flex-col gap-8', disableContactOptions ? 'max-w-[1000px]' : 'max-w-[800px]')}>
        <h3 className='font-semibold text-2xl text-center'>Dúvidas frequentes</h3>
        <FAQBox primaryColor={primaryColor} {...rest} />
      </div>

      {!disableContactOptions && (
        <div className='flex flex-col items-center justify-center gap-8 w-full lg:w-1/2 xl:w-1/3'>
          <div className='hidden lg:flex justify-center items-center w-full'>
            {image ? (
              <GatsbyImage image={image} className='w-[300px]' alt='Imagem de uma pessoa com expressão de dúvida' />
            ) : (
              <StaticImage
                src='../../images/resources/topo-lp-1.png'
                alt='Imagem de uma pessoa com expressão de dúvida'
                placeholder='blurred'
                quality={100}
              />
            )}
          </div>

          <div className='flex flex-col gap-2 text-center'>
            <h3 className='font-semibold text-2xl'>Ainda está com dúvidas?</h3>
            <p>Fale agora com nossos especialistas!</p>
          </div>
          <AvailableFormsOfService primaryColor={primaryColor} />
        </div>
      )}
    </div>
  )
}

export default FAQ
